import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { ThemeFromLogo } from './ThemeFromLogo';

export interface Branding {
  appName: string;
  productName: string;
  logoUrl: string;
  colors: {
    primary: string;
    primaryDark: string;
    slate: string;
    graphite: string;
    line: string;
    mist: string;
  };
  footer: string;
}

/** Paleta base extraída da logo Integratio (i vermelho + wordmark cinza-ardósia). */
export const DEFAULT_BRANDING: Branding = {
  appName: 'Integratio',
  productName: 'Gerador de Relatórios de Stakeholders',
  logoUrl: '/logo.png',
  colors: {
    primary: '#D9111C',
    primaryDark: '#8B1013',
    slate: '#54525E',
    graphite: '#2F2E36',
    line: '#E5E5EA',
    mist: '#F7F7F9',
  },
  footer: 'Integratio · Relatório de Análise de Stakeholders · Uso interno',
};

const BrandingContext = createContext<Branding>(DEFAULT_BRANDING);

export function useBranding(): Branding {
  return useContext(BrandingContext);
}

export function BrandingProvider({ children }: { children: ReactNode }): JSX.Element {
  const value = useMemo(() => DEFAULT_BRANDING, []);
  return (
    <BrandingContext.Provider value={value}>
      <ThemeFromLogo logoUrl={value.logoUrl} fallback={value.colors} />
      {children}
    </BrandingContext.Provider>
  );
}
